(function () {
  'use strict';

  function parseMoney(text) {
    if (!text) return NaN;
    var normalized = text.replace(/[^0-9,.-]/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    return parseFloat(normalized);
  }

  function formatMoney(value) {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function addMiniCartRecommendation(button) {
    var variantId = button && button.dataset.variantId;
    if (!variantId || button.disabled) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adicionando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart');
      return response.json();
    }).then(function () {
      button.textContent = 'Adicionado ✓';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    }).catch(function () {
      button.disabled = false;
      button.textContent = 'Tentar novamente';
      window.setTimeout(function () { button.textContent = originalText; }, 1800);
    });
  }

  function updatePriceDetails(variant) {
    var priceElement = document.querySelector('.product-form__info-item .price--highlight');
    var compareElement = document.querySelector('.product-form__info-item .price--compare');
    var installmentElement = document.querySelector('.product-price-installments');
    if (!priceElement || !installmentElement) return;

    var price = variant && typeof variant.price === 'number' ? variant.price / 100 : parseMoney(priceElement.textContent);
    var comparePrice = variant ? (typeof variant.compare_at_price === 'number' ? variant.compare_at_price / 100 : NaN) : parseMoney(compareElement && compareElement.textContent);
    if (!Number.isFinite(price)) return;

    var count = Math.max(1, parseInt(installmentElement.dataset.installmentCount, 10) || 12);
    var multiplier = parseFloat(installmentElement.dataset.priceMultiplier) || 1;
    var installment = (price * multiplier) / count;
    installmentElement.innerHTML = 'Em até ' + count + 'x de <span><b>' + formatMoney(installment) + '</b></span>';

    if (Number.isFinite(comparePrice) && comparePrice > price) {
      var automaticPercent = Math.round(((comparePrice - price) * 100) / comparePrice);
      var percentageBadge = document.querySelector('.discount__percentage');
      var manualPercent = percentageBadge ? parseInt(percentageBadge.dataset.manualDiscount, 10) || 0 : 0;
      var shownPercent = manualPercent > 0 ? manualPercent : automaticPercent;
      var percentText = document.querySelector('[data-discount-percent]');
      if (percentText) percentText.textContent = shownPercent + '%';

      var savingsBadge = document.querySelector('[data-discount-template]');
      if (savingsBadge) {
        var template = savingsBadge.dataset.discountTemplate || '[valor] de desconto';
        var savingsValue = savingsBadge.dataset.manualSavings || formatMoney(comparePrice - price);
        savingsBadge.textContent = template.replace('[valor]', savingsValue).replace('[percentual]', shownPercent);
      }
    }
  }

  function initialize() {
    document.addEventListener('click', function (event) {
      var miniCartRecommendation = event.target.closest('[data-mini-cart-recommendation-add]');
      if (miniCartRecommendation) addMiniCartRecommendation(miniCartRecommendation);
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches('.block-swatch__radio, .color-swatch__radio, .variant-swatch__radio, .product-form__single-selector')) return;
      window.setTimeout(function () { updatePriceDetails(); }, 160);
    });

    document.addEventListener('variant:changed', function (event) {
      window.setTimeout(function () { updatePriceDetails(event.detail && event.detail.variant); }, 60);
    });

    document.addEventListener('product:added', function () {
      window.setTimeout(function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 300);
    });

    updatePriceDetails();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
